import { AlertService, IAlert } from './../alert.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  message: IAlert;
  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.alertService.alertMessage.subscribe(message => {
      this.message = message;
    })
  }
  doneMessageView() {
    this.alertService.doneAlert()
  }

}
